import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Intent } from 'onevoice';
import { Context } from './context.service';

export interface ContextIntent {
    id?: number;
    intent?: Intent;
    input?: boolean;
    required?: boolean;
    context?: Context;
}

@Injectable({
    providedIn: 'root'
})
export class ContextIntentService {
    url: string = `${environment.coreService}/api/intents/contexts`;

    constructor(private _httpClient: HttpClient) { }

    list(intent?: number): Observable<ContextIntent[]> {
        let params: HttpParams = new HttpParams();
        if (intent) {
            params = params.set('intent', `${intent}`);
        }
        return this._httpClient.get<ContextIntent[]>(this.url, {
            params: params
        });
    }

    get(id: number): Observable<ContextIntent> {
        return this._httpClient.get<ContextIntent>(`${this.url}/${id}`);
    }

    create(data: ContextIntent): Observable<ContextIntent> {
        return this._httpClient.post<ContextIntent>(this.url, data);
    }

    update(data: ContextIntent): Observable<ContextIntent> {
        return this._httpClient.post<ContextIntent>(
            `${this.url}/${data.id}`,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }
        );
    }

    delete(data: ContextIntent): Observable<any> {
        return this._httpClient.delete(`${this.url}/${data.id}`);
    }
}
